module.exports = __webpack_public_path__ + "static/media/icon-brandidentity.cd6b30ca.svg";